define('admin/teams/teams',['jquery', 'plugins/http', 'knockout', 'durandal/app', 'durandal/activator', 'durandal/composition'], function($, http, ko, app, activator, composition) {
    var viewmodel = function() {
        var self = this;

        self.page = 1;
        self.canLoadMoreTeams = ko.observable(false);
        self.loadingTeams = ko.observable(false);
        self.totalTeams = ko.observable(0);
        self.teams = ko.observableArray([]);
        self.hasTeams = ko.computed(function() {
            return self.teams().length > 0;
        });
        self.newTeamName = ko.observable();
        self.newTeamDescription = ko.observable();
        self.teamDetailsContent = ko.observable();
        self.teamUsersActivator = activator.create();
        
        self.activate = function () {
            self.refreshTeams();
        };

        self.refreshTeams = function () {
            self.teams.removeAll();
            self.newTeamName('');
            self.newTeamDescription('');

            self.loadNextPageOfTeams();
        };

        self.loadNextPageOfTeams = function() {
            self.getTeamsForCompany()
                .then(self.processTeams)
                .fail(app.showError);
        };

        self.processTeams = function (response) {
            var teams = response.data.teams,
                teamsLen = teams.length;

            self.loadingTeams(false);

            for (var i = 0; i < teamsLen; i++) {
                self.teams.push({
                    id: ko.observable(teams[i].id),
                    name: ko.observable(teams[i].name),
                    description: ko.observable(teams[i].description),
                    //memberCount: ko.observable(teams[i].memberCount),
                    //mapCount: ko.observable(teams[i].mapCount),
                    isEditing: ko.observable(false)
                });
            }

            self.canLoadMoreTeams(response.data.moreToCome);
            self.totalTeams(response.data.total);

            if (response.data.moreToCome) {
                self.page++;
            }
        };
        
        // ui commands
        self.createNewTeam = function () {
            var team = {
                name: self.newTeamName(),
                description: self.newTeamDescription()
            };

            self.saveTeam(team)
                .then(self.refreshTeams)
                .fail(app.showError);
        };

        self.toggleTeamDetails = function (team, e) {
            if (e.target.nodeName === 'INPUT') {
                e.stopPropagation();
                return;
            }

            var target = $(e.target).closest('[data-target]').data('target'),
                container = $(target).find('div');

            if (!container.children().length) {
                composition.compose(container.get(0), {
                    activate: true,
                    model: 'admin/teams/teamUsers',
                    activationData: [team.id]
                });
            }
        };

        self.toggleEditTeamDetails = function(team, e) {
            e.stopPropagation();

            team.isEditing(true);
        };

        self.cancelEditTeamDetails = function (team, e) {
            e.stopPropagation();

            team.isEditing(false);
        };
        
        self.saveEditTeamDetails = function (team, e) {
            e.stopPropagation();

            team.isEditing(false);
            
            return self.updateTeam(team);
        };

        // api
        self.getTeamsForCompany = function () {
            self.loadingTeams(true);

            var url = '/api/admin/teams/list/' + self.page;

            return http.get(url);
        };

        self.updateTeam = function (team) {
            var url = '/api/admin/teams/update',
                data = {
                    teamId: team.id(),
                    name: team.name(),
                    description: team.description()
                };

            return http.post(url, data);
        };

        self.saveTeam = function (team) {
            var url = '/api/admin/teams/create';

            return http.post(url, team);
        };
    };

    return viewmodel;
});

